export default "__VITE_ASSET__$nA7Am3b__"